<template>
    <div style="padding-right: 75px;">
        <div class="mt-1 app-left-margin w-100"  >
            <v-app-bar color="white" elevation="0"  height="45" style="padding-right: 75px">
                <v-app-bar-nav-icon
                    @click="drawer=true"
                    class="primary--text"
                    style="margin-top: -2px"
                />
                <v-toolbar-title class="primary--text">EINSTELLUNGEN</v-toolbar-title>
                <v-spacer/>

                <div class="float-right" style="display: flex">
                    <nav-user-menu />
                </div>
            </v-app-bar>

            <v-navigation-drawer
                v-model="drawer"
                absolute
                temporary
            >
                <c-app-side-drawer
                    @close="onCloseSide ()"
                />
            </v-navigation-drawer>
        </div>

        <div class="v-flex app-left-margin">
            <v-tabs
                v-model="tab"
                class="mt-0 folder-tabs ml-0 mr-0 pr-0"
                active-class="folder-tab-active primary"
                show-arrows
                height="40"
            >
                <v-tabs-slider color="primary"></v-tabs-slider>
                <v-tab
                    class="folder-tab"
                    :key="1"
                >
                    Standardmails
                </v-tab>
                <v-tab
                    class="folder-tab"
                    :key="2"
                >
                    Signaturen
                </v-tab>
                <v-tab
                    class="folder-tab"
                    :key="3"
                >
                    Stempel
                </v-tab>

                <v-tabs-items v-model="tab">
                    <v-tab-item :key="1">
                        <template-mails ref="tab" />
                    </v-tab-item>

                    <v-tab-item :key="2">
                        <template-signatures ref="tab"  />
                    </v-tab-item>

                    <v-tab-item :key="3">
                        <c-preferences-details-stamp />
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
    </div>
</template>

<script>

import Core                from "@/modules/core/service/Core";
import TemplateMails       from "@/modules/msd/templates/components/TemplateMails";
import TemplateSignatures  from "@/modules/msd/templates/components/TemplateSignatures";
import NavUserMenu         from "@/modules/msd/user/components/nav/NavUserMenu";
import CAppSideDrawer      from "@/modules/core/components/app/CAppSideDrawer";
import CPreferencesDetailsStamp from "@/modules/msd/preferences/components/main/CPreferencesDetailsStamp.vue";

export default {
    name: "MPreferences",

    components: {
        CPreferencesDetailsStamp,
        CAppSideDrawer,
        NavUserMenu,
        TemplateSignatures,
        TemplateMails,
    },

    data: () => ({
        tab: 0,
        drawer : false,
    }),

    computed: {
        liftmanager() {
            return Core.role.liftmanager();
        },
    },

    mounted() {
        Core.init.load(this.$store, false);
    },

    methods: {
        onSave () {
            this.$refs.tab.save ();
        },

        onCloseSide () {
            this.drawer = false;
        },

    }
}
</script>

<style scoped>

::v-deep .theme--light.v-tabs>.v-tabs-bar {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: lightgray;
}

::v-deep .v-overlay__scrim {
    opacity: 0.0!important;
    color: white;
}

::v-deep .v-toolbar__content,
::v-deep .v-toolbar__content i {
    font-size: 15pt;
    padding: 0;
}

::v-deep .v-toolbar__title {
    font-weight: 700;
    padding-left: 0!important;
    font-size: 15pt;
}


.nav-search-input input {
    outline: none;
    width: 100%;
}

::v-deep .v-btn__content {
    align-items: start;
}

::v-deep .v-menu__content {
    padding-left: 10px;
    padding-right: 10px;
    background-color: white;
    min-width: 16rem !important;
}

.nav-search-icon i {
    color: gray;
    font-size: 13pt;
}

::v-deep .v-navigation-drawer__content {
    overflow: hidden;
}


</style>